//专家
import axios from "axios"
export default {
    getExpertsAsync: async (params) => {//获取专家列表
        return axios.get('/get_expert_list', { params: params })
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    addExpertAsync: async (data) => {//专家申请
        return axios.post('/add_expert', data)
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    expertDetailAsync: async (params) => {//专家详情
        return axios.get('/expert_detail', { params: params })
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    expertInviteAsync: async (params) => {//专家邀请
        return axios.get('/get_invite_data', { params: params })
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    expertDealInviteAsync: async (data) => {//专家处理邀请
        return axios.post('/accept_invitation', data)
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    getExpertRandomAsync: async (params) => {//抽取专家
        return axios.get('/random_list', { params: params })
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    appendExpertOpusAsync: async (data) => {//添加代表作
        return axios.post('/expert_works', data)
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    removeExpertOpusAsync: async (params) => {//删除代表作
        return axios.get('/del_works', { params: params })
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
}
